import { Mfe, Team } from '../../shared/enums/mfeTeam';
import { ViewDefinitions } from '../../shared/types/view';

// TODO: Remove this view once centralised headings have been launched: https://checkout.atlassian.net/browse/DASH-5206
// TODO: Remove announcement post-launch of new homepage: https://checkout.atlassian.net/browse/DASH-5190
export enum HomepageViewId {
  HEADER = 'headerHomepageView',
  ANNOUNCEMENT = 'announcementView',
}

export const homeViews: ViewDefinitions = {
  home: {
    mfe: Mfe.COMPASS,
    module: './Dashboard',
    metadata: {
      team: Team.CORE,
    },
  },
  // TODO: Remove this view once centralised headings have been launched: https://checkout.atlassian.net/browse/DASH-5206
  [HomepageViewId.HEADER]: {
    mfe: Mfe.FEATURES,
    module: './HeaderSectionView',
    metadata: {
      team: Team.CORE,
    },
  },
  balancesHomepageView: {
    mfe: Mfe.FEATURES,
    module: './BalancesSectionView',
    metadata: {
      team: Team.CORE,
    },
  },
  paymentsHomepageView: {
    mfe: Mfe.FEATURES,
    module: './PaymentsSectionView',
    metadata: {
      team: Team.CORE,
    },
  },
  issuingHomepageView: {
    mfe: Mfe.FEATURES,
    module: './IssuingSectionView',
    metadata: {
      team: Team.CORE,
    },
  },
  // TODO: Remove view post-launch of new homepage: https://checkout.atlassian.net/browse/DASH-5190
  [HomepageViewId.ANNOUNCEMENT]: {
    mfe: Mfe.FEATURES,
    module: './AnnouncementView',
    metadata: {
      team: Team.CORE,
    },
  },
};
